import { Company } from '@/types';
import { Core, COMPANIES } from '../Core';

class Companies extends Core {
  getCompanies = async () => this.get<Company[]>(COMPANIES());

  updateCompanies = async (data: Company) => this.patch(COMPANIES(), data);

  createCompanies = async (data: Company) => this.post(COMPANIES(), data);
}

export const companies = new Companies();
